<template>
  <div class="table_actions">
    <call-tooltip
      v-for="(item) in computedConfigItemBoard"
      :key="item.id"
      :disabled="item.disabled"
      :content="item.title">
      <call-button
        v-show="item.id"
        outlet
        :type="item.type"
        round
        not-border
        :disabled="item.disabled"
        :icon="item.icon"
        @click="clickAction(item.id)" />
    </call-tooltip>
    <popover
      v-if="!data.item.is_archived"
      ref="popover"
      v-model="localShow"
      custom-class="my-custom-popover"
      trigger="click"
      placement="bottom-end"
      :overlay="false">
      <div class="my-popover">
        <div class="my-popover__title">
          Actions
        </div>

        <div class="my-popover__wrap">
          <div
            v-for="item in computedConfigItem"
            :key="item.id"
            class="my-popover__item"
            :class="[item.disabled && 'my-popover__item--disabled']"
            @click="clickAction(item.id)">
            <font-awesome-icon
              :class="[item.type, item.disabled && 'disabled']"
              :icon="item.icon" />
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>
      <template #reference>
        <call-button
          class="popover-button"
          outlet
          round
          not-border
          :icon="dataEllipsisIcon" />
      </template>
    </popover>
  </div>
</template>

<script>
import CallButton from '../common/CallButton';
import {
  faEye,
  faPen,
  faCog,
  faPowerOff,
  faBackward,
  faEllipsis,
  faPlay,
  faStop,
  faPause,
  faHistory
} from '@fortawesome/pro-regular-svg-icons';
import Popover from 'vant/lib/popover';

export default {
  name: 'CallTableProjectActions',
  components: { CallButton, Popover },
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    },
    blocked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      localShow: false,
      dataViewIcon: faEye,
      dataReadingIcon: faCog,
      dataLockIcon: faPowerOff,
      dataUnlockIcon: faBackward,
      dataEllipsisIcon: faEllipsis,
      configItem: [
        {
          id: 'view',
          type: 'success',
          icon: faEye,
          title: 'Info'
        },
        {
          id: 'edit',
          type: 'warning',
          icon: faCog,
          title: 'Edit',
          disabled: true
        },
        {
          id: 'play',
          type: 'success',
          icon: faPlay,
          title: 'Play',
          disabled: false
        },
        {
          id: 'pause',
          type: 'warning',
          icon: faPause,
          title: 'Pause',
          disabled: false
        },
        {
          id: 'stop',
          type: 'danger',
          icon: faStop,
          title: 'Stop',
          disabled: false
        },
        {
          id: 'archive',
          type: 'danger',
          icon: faHistory,
          title: 'Archive',
          disabled: false
        }
      ]
    };
  },

  computed: {
    popoverId () {
      return this.data && this.data.item ? this.data.item.id : null;
    },
    computedConfigItem () {
      const result = this.configItem.filter((item) => {
        if (!this.data.permissions.auto_call_run_update_allowed &&
          item.id === 'edit' && this.data.item.is_archived) {
          return false;
        }
        if (!this.data.permissions.auto_call_run_pause_allowed &&
          item.id === 'pause') {
          return false;
        }
        if (!this.data.permissions.auto_call_run_resume_allowed &&
          item.id === 'play') {
          return false;
        }
        if (!this.data.permissions.auto_call_run_stop_allowed &&
          item.id === 'stop') {
          return false;
        }
        if (!this.data.permissions.auto_call_run_archive_allowed &&
          item.id === 'archive') {
          return false;
        }
        return true;
      }).map(item => {
        if (this.data.item.type !== 'auto' &&
          item.id === 'edit') {
          return { ...item, disabled: true };
        }
        return { ...item, disabled: false };
      });

      return result;
    },

    computedConfigItemBoard () {
      return this.computedConfigItem.filter(item => {
        return item.id === 'view' || item.id === 'edit';
      });
    }
  },

  watch: {
    '$store.state.misc.activePopoverId' (id) {
      if (id === this.popoverId) {
        this.localShow = true;
      } else if (this.localShow) {
        this.localShow = false;
      }
    },
    localShow (val) {
      if (val) {
        this.$store.dispatch('misc/setActivePopoverId', this.popoverId);
      }
    }
  },

  mounted () {
    document.addEventListener('mousedown', this.handleOutsideMouseDown, true);
  },

  beforeDestroy () {
    document.removeEventListener('mousedown', this.handleOutsideMouseDown, true);
  },

  methods: {
    clickAction (action) {
      this.localShow = false;
      this.$emit('on-action', action);
    },

    handleOutsideMouseDown (event) {
      // Ранний выход: если поповер закрыт, ничего не делаем
      if (!this.localShow) return;

      const target = event.target;

      // Клик внутри reference-кнопки или обёртки компонента
      if (this.$el.contains(target)) return;

      // Клик внутри самого Vant Popover (который teleport-ится в body)
      if (target.closest('[class*="van-popover"]')) return;

      // Закрываем поповер, НЕ останавливая событие.
      // Это позволяет b-table и другим элементам получить
      // полноценный mousedown → click цикл.
      this.localShow = false;
    }
  }
};
</script>

<style lang="scss">
.van-popup[data-popper-placement="bottom-end"] {
  .van-popover__arrow {
    display: none;
  }
}
.my-popover {
  display: flex;
  flex-direction: column;
  padding: 8px 8px;
  min-width: 136px;
  // margin-left: -16px !important;
  // padding-left: 24px;

  &__title {
    padding: 8px;
    font-size: 14px;
    font-family: 'cera-bold', sans-serif;
    color: #222;
  }

  &__wrap {
    display: flex;
    flex-direction: column;
  }

  &__item {
    font-size: 12px;
    padding: 8px;
    width: 120px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all .2s;

    &--disabled {
      pointer-events: none;
      cursor: not-allowed;
      opacity: 0.5;
    }

    &:hover {
      border-radius: 8px;
      background-color: #e8f5ed;
      cursor: pointer;
    }
  }
}
</style>
